import React, { useMemo } from "react";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { useAppDispatch } from "../../Store/hooks";
import { useNotifier } from "../../Core/Notifier";
import { useLoginMutation } from "../../Api/attoDeskApi";
import { useFormik } from "formik";
import { IAuth } from "../../Api/Interface/api.interface";
import { setEnableAuth } from "../../Store/Auth/AuthSlice";
import { useNavigate } from "react-router-dom";
import { Privileges } from "../../Core/Enum/enum";
import useIsMobile from "../../Core/hook/useIsMobile";

const companyLogo = localStorage.getItem("companyLogo");

const Login: React.FC = () => {
  // const navigate = useNavigate();
  // const authContext = useContext(AuthContext);

  // if (!authContext) {
  //   return null;
  // }

  // const { login } = authContext;

  // const handleLogin = () => {
  //   login();
  //   navigate("/dashboard");
  // };
  const dispatch = useAppDispatch();
  const { showErrorMessage } = useNotifier();
  const [login, { isLoading }] = useLoginMutation();
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    onSubmit: async (values) => {
      try {
        const loginResponse = await login(values).unwrap();
        if (!loginResponse.status) {
          showErrorMessage(loginResponse.message);
        } else {
          const tokenData = loginResponse.data as IAuth;
          localStorage.setItem("token", tokenData.token);
          if (tokenData.lightThemeColor) {
            localStorage.setItem(
              "lightThemeColor",
              JSON.stringify(tokenData.lightThemeColor)
            );
          }
          if (tokenData.darkThemeColor) {
            localStorage.setItem(
              "darkThemeColor",
              JSON.stringify(tokenData.darkThemeColor)
            );
          }
          dispatch(setEnableAuth());
          navigateBasedOnPrivileges(loginResponse.privileges);
          window.location.reload();
        }
      } catch (error) {
        showErrorMessage("Please check you username or password");
      }

      // navigate('/dashboard');
    },
  });
  const formValid = useMemo(() => {
    return formik.values.username === "" || formik.values.password === ""
      ? false
      : true;
  }, [formik]);

  const navigateBasedOnPrivileges = (privileges: string[]) => {
    if (privileges.includes(Privileges.DashboardView)) {
      navigate("/dashboard");
    } else if (privileges.includes(Privileges.DepartmentView)) {
      navigate("/department/list");
    } else if (privileges.includes(Privileges.StoreView)) {
      navigate("/store/list");
    } else if (privileges.includes(Privileges.UserView)) {
      navigate("/user/list");
    } else if (privileges.includes(Privileges.OrderList)) {
      navigate("/order/list");
    } else if (privileges.includes(Privileges.SettingView)) {
      navigate("/setting");
    } else if (privileges.includes(Privileges.CategoriesView)) {
      navigate("/category/list");
    } else if (privileges.includes(Privileges.LoopingView)) {
      navigate("/looping/list");
    } else if (privileges.includes(Privileges.BranchView)) {
      navigate("/branch/list");
    } else if (privileges.includes(Privileges.TaxView)) {
      navigate("/tax/list");
    } else if (privileges.includes(Privileges.PrinterView)) {
      navigate("/printer/list");
    } else if (privileges.includes(Privileges.PrivilegeView)) {
      navigate("/user/privilege/list");
    } else if (privileges.includes(Privileges.UserRoleView)) {
      navigate("/user/role/list");
    } else if (privileges.includes(Privileges.ItemsView)) {
      navigate("/main/item/list");
    } else if (privileges.includes(Privileges.ItemsView)) {
      navigate("/product/list");
    } else if (privileges.includes(Privileges.TagView)) {
      navigate("/tag/list");
    } else if (privileges.includes(Privileges.BranchView)) {
      navigate("/brand/list");
    } else if (privileges.includes(Privileges.StaffView)) {
      navigate("/team/list");
    } else if (privileges.includes(Privileges.PositionView)) {
      navigate("/position/list");
    } else if (privileges.includes(Privileges.ScheduleView)) {
      navigate("/schedule/list");
    } else if (privileges.includes(Privileges.ScheduleView)) {
      navigate("/schedule/list/calender/one-day");
    } else if (privileges.includes(Privileges.PayrollView)) {
      navigate("/payroll/list");
    } else if (privileges.includes(Privileges.EmailView)) {
      navigate("/email/setting/list");
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box
        sx={{
          backgroundColor: "white",
          boxShadow: 3,
          p: isMobileRes ? 3 : 5,
          maxWidth: 500,
          width: isMobileRes ? "100%" : "90%",
          mx: "auto",
          height: "auto",
        }}
      >
        {companyLogo && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              pb: isMobileRes ? 2 : 4,
            }}
          >
            <img
              src={companyLogo}
              alt="Dcc"
              style={{
                width: isMobileRes ? "70%" : "80%",
                height: "auto",
                display: "block",
              }}
            />
          </Box>
        )}

        <TextField
          fullWidth
          variant="filled"
          label="Username"
          margin="normal"
          sx={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #CCCCCC",
          }}
          {...formik.getFieldProps("username")}
        />

        <TextField
          fullWidth
          variant="filled"
          label="Password"
          type="password"
          margin="normal"
          sx={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #CCCCCC",
          }}
          {...formik.getFieldProps("password")}
        />

        <Button
          fullWidth={isMobileRes}
          variant="contained"
          disabled={!formValid || isLoading}
          type="submit"
          sx={{ mt: 2 }}
        >
          {isLoading && (
            <Box sx={{ pr: 2, pt: 0.5 }}>
              <CircularProgress size={16} sx={{ color: "white" }} />
            </Box>
          )}
          Login
        </Button>
      </Box>
    </form>
  );
};

export default React.memo(Login);
